// src/RouteError.tsx
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import Box from "@mui/material/Box/index.js";
import Typography from "@mui/material/Typography/index.js";
import Button from "@mui/material/Button/index.js";
import { jsx, jsxs } from "react/jsx-runtime";
var RouteError = () => {
  const error = useRouteError();
  if (isRouteErrorResponse(error)) {
    console.error("Route error:", error.status, error.statusText);
  } else {
    console.error("Route error:", error);
  }
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        minHeight: "50vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        py: 6
      },
      children: [
        /* @__PURE__ */ jsx(Typography, { sx: { mb: 2 }, children: "Something went wrong loading this page." }),
        /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: () => window.location.reload(), children: "Reload" })
      ]
    }
  );
};
export {
  RouteError
};
